import React from 'react'
import {Icon} from '@therms/atalaya'
import {MobileMenuLink} from '@src/modules/Layout/shared/MobileMenuLink'
import {MAIL_ROUTES} from '../../constants'
import {IoMdMail} from 'react-icons/io'

function MailMobileMenuLink() {
  return (
    <MobileMenuLink to={MAIL_ROUTES.__ROOT__}>
      <div className="flex flex-col items-center">
        <Icon Icon={IoMdMail} />
        <span>Mail</span>
      </div>
    </MobileMenuLink>
  )
}

export {MailMobileMenuLink}
